import { Component, OnInit, forwardRef } from "@angular/core";
import { FormBuilder, FormsModule } from "@angular/forms";
import {
  NavController,
  NavParams,
  ToastController,
  ModalController,
  LoadingController,
  IonicModule,
} from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { MdaProvider } from "src/app/services/mda/mda";
import { UserProvider } from "src/app/services/user/user";
import { HistoricoPage } from "../../historico/historico.page";
import { MdaEncontroDesmarcarPage } from "../mda-encontro-desmarcar/mda-encontro-desmarcar.page";
import { MdaEncontroRemarcarPage } from "../mda-encontro-remarcar/mda-encontro-remarcar.page";
import { CommonModule } from "@angular/common";

import { DateFormatPipe } from "src/app/pipes/date-format/date-format";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";

@Component({
  selector: "app-mda-detalhes-encontro",
  templateUrl: "./mda-detalhes-encontro.page.html",
  styleUrls: ["./mda-detalhes-encontro.page.scss"],
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, DateFormatPipe, TranslateModule, LoadingSpinnerComponent],
})
export class MdaDetalhesEncontroPage implements OnInit {
  loaded: boolean = false;
  mda: any = { pessoa: {}, dadosMDA: { proximoEncontro: {} }, ultimosEncontros: [] };
  titulo: string = "";
  discipulador: boolean = false;
  mostrarTodos: boolean = false;
  id: string = "";

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public mdaProvider: MdaProvider,
    public toastCtrl: ToastController,
    public modalCtrl: ModalController,
    public loadingController: LoadingController,
    private translate: TranslateService,
    public userProvider: UserProvider
  ) {
    this.mda = this.navParams.get("mda");
    this.mdaProvider.getByMda(this.mda.dadosMDA.id).subscribe((data) => {
      this.titulo = data.titulo;
      this.discipulador = data.discipulador;
      this.mda = data;

      setTimeout(() => {
        this.loaded = true;
      },1000);
    });
  }

  ngOnInit() {}

  async remarcar(mda: any) {
    const data = { mda: mda };
    const modalPage = await this.modalCtrl.create({
      component: MdaEncontroRemarcarPage,
      componentProps: data,
    });
    modalPage.present();

    const dismissModal = await modalPage.onWillDismiss();

    if (dismissModal.data?.acao) {
      this.mdaProvider.getByMda(this.mda.dadosMDA.id).subscribe((data) => {
        this.mda = data;
      });
    }
  }

  confirmar(idEncontro: any) {
    this.mdaProvider.confirmarEncontro(idEncontro).subscribe((data) => {
      this.mdaProvider.getByMda(this.mda.dadosMDA.id).subscribe((data) => {
        this.titulo = data.titulo;
        this.discipulador = data.discipulador;
        this.mda = data;
      });
    });
  }

  async desmarcar(mda: any) {
    var data = { mda: mda, desmarcadoPor: this.discipulador ? 0 : 1 };
    const modalPage = await this.modalCtrl.create({
      component: MdaEncontroDesmarcarPage,
      componentProps: data,
    });
    modalPage.present();

    const dismissModal = await modalPage.onWillDismiss();

    if (dismissModal.data) {
      await this.modalCtrl.dismiss(true);
      return;
    }

    if (dismissModal.data) {
      this.mdaProvider.getByMda(this.mda.dadosMDA.id).subscribe((data) => {
        this.titulo = data.titulo;
        this.discipulador = data.dicipulador;
        this.mda = data;
      });
    }
  }

  async addHistorico(mda: { dadosMDA: { id: any; proximoEncontro: { id: any } } }) {
    var data = { idMda: mda.dadosMDA.id, idMdaEncontro: mda.dadosMDA.proximoEncontro.id };
    const modalPage = await this.modalCtrl.create({ component: HistoricoPage, componentProps: data, animated:false });
    modalPage.present();

    const dismissModal = await modalPage.onWillDismiss();

    if (dismissModal.data) {
      await this.modalCtrl.dismiss(true);
      return;
    }

    if (dismissModal.data) {
      this.mdaProvider.getByMda(this.mda.dadosMDA.id).subscribe((data) => {
        this.titulo = data.titulo;
        this.discipulador = data.dicipulador;
        this.mda = data;
      });
    }
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
